import { isChecklistAllowedTaskType } from 'helpers/taskTypeAvailability'
import { stripPositionId } from 'ui/components/checklist/ChecklistForm/helpers'

export const prepareTaskTemplatePayload = ({
  task_type,
  name,
  content,
  checklists = [],
}) => {
  const taskTypeId = task_type?.id ?? task_type

  return {
    task_type: taskTypeId,
    name: name.trim(),
    content,
    checklists: isChecklistAllowedTaskType(taskTypeId)
      ? stripPositionId(checklists)
      : [],
  }
}
